import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {IdentityModel, UpdateIdentityRequest} from '../models/identity.model';
import {AuthenticatorModel} from "../models/authenticator.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SelfManageService {

  endpoint = environment.API_URL + "rest/vsm";

  identity: IdentityModel;

  constructor(
    private http: HttpClient,
  ) {
  }

  fetchDetails() {
    return this.http
      .get<any>(
        this.endpoint + "/identity")
      .pipe(
        map(responseData => {
          this.identity = this.toIdentity(responseData.username, responseData.profile, '');
          if (responseData?.error?.errorDescription.length > 0) {
            this.identity.error = responseData.error.errorDescription;
          }
          return this.identity;
        })
      )
  }

  updateProfile(update: UpdateIdentityRequest) {
    return this.http
      .put<any>(
        this.endpoint + "/identity", update)
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  remove() {
    return this.http
      .delete<any>(
        this.endpoint + "/identity/delete")
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  unblock() {
    return this.http
      .put<any>(
        this.endpoint + "/identity/unblock", {})
      .pipe(
        map(responseData => {
          return responseData;
        })
      )
  }

  getLoadedIdentity() {
    return this.identity;
  }

  toIdentity(username: string, data: any, error: string) {
    if (!data) {
      return new IdentityModel('', '', '', null, '', '', '', '', '', '', '', username, '', '', error);
    }
    return new IdentityModel(
      data.id,
      data.identityStatus,
      data.externalProfileId,
      new Date(data.registrationTime),
      data.displayName,
      data.externalValues.firstname,
      data.externalValues.lastname,
      data.emailAddress,
      data.phoneNumber,
      data.upn,
      data.integrationExternalId,
      username,
      data.language,
      data.customPhoneNumber,
      ''
    );
  }

}
